"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skin = void 0;
var player_config_1 = require("../typings/player-config");
var replaceContentfulUrl_1 = __importDefault(require("../utilities/replaceContentfulUrl"));
var Skin = (function () {
    function Skin(clientSkin, apiSkin) {
        var _this = this;
        this.name = null;
        this.url = null;
        var _a = apiSkin || {}, name = _a.name, cssFile = _a.cssFile, controlbarText = _a.controlbarText, controlbarIcons = _a.controlbarIcons, controlbarIconsActive = _a.controlbarIconsActive, controlbarBackground = _a.controlbarBackground, timesliderProgress = _a.timesliderProgress, timesliderRail = _a.timesliderRail, menusText = _a.menusText, menusTextActive = _a.menusTextActive, menusBackground = _a.menusBackground, tooltipsText = _a.tooltipsText, tooltipsBackground = _a.tooltipsBackground, titlePosition = _a.titlePosition, playButtonBackground = _a.playButtonBackground;
        this.name = name || null;
        this.url = (0, replaceContentfulUrl_1.default)(cssFile === null || cssFile === void 0 ? void 0 : cssFile.url) || null;
        this.controlbar = {
            text: controlbarText || '#FFFFFF',
            icons: controlbarIcons || 'rgba(255,255,255,0.8)',
            iconsActive: controlbarIconsActive || '#FFFFFF',
            background: controlbarBackground || 'rgba(0,0,0,0)',
        };
        this.timeslider = {
            progress: timesliderProgress || '#F2F2F2',
            rail: timesliderRail || 'rgba(255,255,255,0.3)',
        };
        this.menus = {
            text: menusText || 'rgba(255,255,255,0.8)',
            textActive: menusTextActive || '#FFFFFF',
            background: menusBackground || '#333333',
        };
        this.tooltips = {
            text: tooltipsText || '#000000',
            background: tooltipsBackground || '#FFFFFF',
        };
        this.titlePosition = titlePosition || player_config_1.TitlePositions.TOP_LEFT;
        this.playButtonBackground = playButtonBackground || null;
        if (clientSkin) {
            Object.keys(clientSkin).forEach(function (key) {
                if (typeof _this[key] === 'undefined') {
                    console.warn("Invalid skin option \"".concat(key, "\""));
                    return;
                }
                _this[key] = clientSkin[key];
            });
        }
    }
    return Skin;
}());
exports.Skin = Skin;
